import React from 'react';
import './SkillCard.css';

const SkillCard = ({ skillGroup, isVisible, animationDelay }) => {
  const IconComponent = skillGroup.icon;
  
  return (
    <div 
      className={`skill-card glass glass-hover card-3d ${
        isVisible ? 'animate-scale-in' : 'opacity-0'
      }`}
      style={{ animationDelay: `${animationDelay}s` }}
    >
      <div className="skill-header">
        <div className={`skill-icon-wrapper skill-icon-${skillGroup.color}`}>
          <IconComponent className={`skill-icon skill-icon-color-${skillGroup.color}`} />
        </div>
        <h3 className="skill-category">{skillGroup.category}</h3>
      </div>
      <div className="skill-items">
        {skillGroup.items.map((skill, i) => (
          <span key={i} className="skill-tag tech-tag">
            {skill}
          </span>
        ))}
      </div>
    </div>
  );
};

export default SkillCard;
